import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './auth/login/login.component';
import { SignedOutComponent } from './base/signed-out/signed-out.component';
import { AboutComponent } from './about/about.component';
import { SettingsComponent } from './settings/settings.component';
import { isLoggedInGuard } from './guards/is-logged-in.guard';
import { RolesComponent } from './admin/roles/roles.component';
import { UsersComponent } from './users/users/users.component';
import { UserProfileComponent } from './users/user-profile/user-profile.component';
import { ControlParamsComponent } from './control-params/control-params.component';
import { controlParamsResolver } from './resolvers/control-params.resolver';
import {
  alignJustifyIcon,
  parametersUnknownIcon,
  SVGIcon,
  windowIcon,
} from "@progress/kendo-svg-icons";
import { ContactUsComponent } from './common-pages/contact-us/contact-us.component';
import { PrivacyComponent } from './common-pages/privacy/privacy.component';
import { DisclaimerComponent } from './common-pages/disclaimer/disclaimer.component';
import { TermsCheckComponent } from './common-pages/terms-conditions/terms-check.component';
import { TermsConditionsComponent } from './common-pages/terms-conditions/terms-conditions.component.js';
import { CopprInfoComponent } from './common-pages/coppr-info/coppr-info.component.js';
import { HomeLoggedOutComponent } from './home-logged-out/home-logged-out.component';
import { homeSelectGuard } from './guards/home-select.guard';
import { TestRouteParamComponent } from './tests/test-route-param/test-route-param.component';
import { EnquiresListComponent } from './admin/enquires-list/enquires-list.component';
import { DisciplineListComponent } from './discipline/discipline-list.component/discipline-list.component';
import { OrganisationListComponent } from './organisation/organisation-list.component/organisation-list.component';
import { HelpInfoComponent } from './admin/help-info/help-info.component';
import { EditPolicyComponent } from './admin/edit-policy/edit-policy.component';
import { ResetPasswordView } from './auth/reset-password-view/reset-password-view';
import {EvaluationListComponent} from './evaluation/evaluation-list.component/evaluation-list.component';
import {SignupComponent} from './auth/signup/signup.component';
import {
  PlacementReviewListComponent
} from './placement-review/placement-review-list.component/placement-review-list.component';
import {AssessmentListComponent} from './assessment/assessment-list.component/assessment-list.component';
import {
  MyPlacementReviewListComponent
} from './my-placement-review/my-placement-review-list.component/my-placement-review-list.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import {
  ResearchDataExportComponent
} from './researchDataExport/research-data-export.component/research-data-export.component';
import { TestPage } from './tests/test-page/test-page';

const wIcon: SVGIcon = windowIcon;
const alignIcon: SVGIcon = alignJustifyIcon;
const parametersIcon: SVGIcon = parametersUnknownIcon;

export const routes: Routes = [
  {
    path: 'home',
    // canActivate: [homeSelectGuard],
    component: HomeComponent,
    title: 'Reflexis - Home'
  },
  // {
  //   path: 'home-logged-out',
  //   component: HomeLoggedOutComponent
  // },
  {title: 'Reflexis - Login', path: 'login', component: LoginComponent},
  { title: 'Sign Up', path: 'auth-sign-up', component: SignupComponent },
  {
    title: 'Reflexis - Signed Out', path: 'signed-out',
    component: SignedOutComponent
  },
  {
    title: 'Reflexis - About Us', path: 'about',
    component: AboutComponent
  },
  {
    title: 'Reflexis - COPPR', path: 'coppr',
    component: CopprInfoComponent
  },
  {
    title: 'Test Page', path: 'test-page',
    component: TestPage
  },
  {
    title: 'Reflexis - Settings', path: 'settings',
    component: SettingsComponent
  },
  {
    title: 'Reflexis - Roles', path: 'roles',
    component: RolesComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Users', path: 'users',
    component: UsersComponent,
    canActivate: [isLoggedInGuard]
  },
  { title: 'Reflexis - User Details', path: 'user-profile',
    component: UserProfileComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Control Params', path: 'controlparams',
    component: ControlParamsComponent,
    canActivate: [isLoggedInGuard],
    resolve: {
      controlParams: controlParamsResolver
    }

  },
  {
    title: 'Reflexis - Reset Password',
    path: 'reset-password',
    component: PasswordResetComponent
  },
  {
    title: 'Reflexis - Password Reset Link',
    path: 'resetpassword',
    component: ResetPasswordView
  },
  {
    path: '',
    // redirectTo: () => {
    //   return `/home`;
    // },
    redirectTo: 'home',
    // redirectTo: function (): "/home" | "/home-logged-out" {
    //   const authTokenService = inject(AuthTokenService);
    //   return authTokenService.isLoggedIn ? '/home' : '/home-logged-out';
    // },
    pathMatch: 'full'
  },
  // {
  //   path: '',
  //   redirectTo: 'home',
  //   pathMatch: 'full'
  // },
  { title: 'Reflexis - Contact Us', path: 'contact-us', component: ContactUsComponent },
  { title: 'Reflexis - New Licence Agreement', path: 'terms-check', component: TermsCheckComponent },
  { title: 'Reflexis - Terms of Use', path: 'terms-conditions', component: TermsConditionsComponent},
  { title: 'Reflexis - Privacy Policy', path: 'privacy', component: PrivacyComponent },
  { title: 'Reflexis - Disclaimer', path: 'disclaimer', component: DisclaimerComponent },
  { title: 'Reflexis - Manage Help Information', path: 'admin-help-info', component: HelpInfoComponent, canActivate: [isLoggedInGuard] },
  { title: 'Reflexis - Edit License Agreement', path: 'admin-edit-policy', component: EditPolicyComponent, canActivate: [isLoggedInGuard] },
  { title: 'Reflexis - Manage Enquiries', path: 'admin-enquires-list', component: EnquiresListComponent, canActivate: [isLoggedInGuard] },
  {
    title: 'Reflexis - Manage Disciplines', path: 'discipline-list',
    component: DisciplineListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Manage Organisations', path: 'organisation-list',
    component: OrganisationListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Manage Evaluations', path: 'evaluation-list',
    component: EvaluationListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Manage Placement Reviews', path: 'placement-review-list',
    component: PlacementReviewListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - My Assessments', path: 'assessment-list',
    component: AssessmentListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - My Placement Reviews', path: 'my-placement-review-list',
    component: MyPlacementReviewListComponent,
    canActivate: [isLoggedInGuard]
  },
  {
    title: 'Reflexis - Research Data Export', path: 'research-data-export',
    component: ResearchDataExportComponent,
    canActivate: [isLoggedInGuard]
  },
  { path: 'test-router/:id', component: TestRouteParamComponent },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

